/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Invoice_Settings_Forbidden_DescInputs */

const vi_invoice_settings_forbidden_desc = /** @type {(inputs: Invoice_Settings_Forbidden_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Liên hệ quản trị viên để được cấp quyền xem cài đặt hóa đơn.`)
};

/**

* @param {Invoice_Settings_Forbidden_DescInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const invoice_settings_forbidden_desc = /** @type {((inputs?: Invoice_Settings_Forbidden_DescInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invoice_Settings_Forbidden_DescInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_invoice_settings_forbidden_desc(inputs)
});